// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#subscription-modal-tank .modal-body,\n#subscription-modal-hsb .modal-body {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n#subscription-modal-tank .legal-text,\n#subscription-modal-hsb .legal-text {\n  font-size: 0.875em;\n  color: var(--gray-600);\n}", ""]);
// Exports
module.exports = exports;
